export default {
    "just_now": "Just now",
    "minutes_ago": "{0} minutes ago",
    "hours_ago": "{0} hours ago",
    "days_ago": "{0} days ago",
    "months_ago": "{0} months ago",
    "years_ago": "{0} years ago",
    "less_than_minute": "Less than minute",
    "minutes_duration": "{0} minutes",
    "hours_duration": "{0} hours",
    "throw_days": "Throw days",
    "all": "All",
    "buyer": "Buyer",
    "seller": "Seller",
    "general-tips": "General Tips",
    "search": "Search",
    "message-text": "Message Text...",
    "response_estimated": "The estimated response time throw {0}",
    "response_time": "Response time",
    "block_user": "Block User",
    "confirmation_question-blocked": "Are you sure, You want to block this user ?",
    "confirmation_question-delete-chat": "Are you sure, You want to delete chat ?",
    "yes": "Yes",
    "no": "No",
    "delete-room": "Delete Chat",
    "download": "download",
    "no_chats_messages": "No chat messages",
    "internet_not_connected_title": "Device not connected",
    "internet_not_connected_description": "Make sure your device has an active Internet connection.",
};
